const t = {
  name: "PhoneAndWatch",
  dimensions: { width: 34, height: 40 },
  content: `
    <g fill="none" stroke="currentColor" clip-path="url(#clip0_12_2628)">
        <path d="M23 39H3.5C2.39543 39 1.5 38.1046 1.5 37V3C1.5 1.89543 2.39543 1 3.5 1H21.5C22.6046 1 23.5 1.89543 23.5 3V17"  stroke-width="2"/>
        <path d="M12.5 6C13.0523 6 13.5 5.55228 13.5 5C13.5 4.44772 13.0523 4 12.5 4C11.9477 4 11.5 4.44772 11.5 5C11.5 5.55228 11.9477 6 12.5 6Z"/>
        <path d="M9.5 35H15.5"  stroke-width="2" stroke-linecap="round"/>
        <rect x="17.5" y="21" width="14" height="14" rx="7"  stroke-width="2"/>
        <path d="M22.5 27.5L24.1667 29C24.1667 29 25.9813 27.3668 27.5 26"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M32.5 27V29"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21.2598 17.771L20.5 21H28.5L27.7402 17.771C27.6339 17.3192 27.2309 17 26.7668 17H22.2332C21.7691 17 21.3661 17.3192 21.2598 17.771Z"  stroke-width="2"/>
        <path d="M27.7402 38.229L28.5 35L20.5 35L21.2598 38.229C21.3661 38.6808 21.7691 39 22.2332 39L26.7668 39C27.2309 39 27.6339 38.6808 27.7402 38.229Z"  stroke-width="2"/>
    </g>
    <defs>
    <clipPath id="clip0_12_2628">
    <rect width="33" height="40" fill="currentColor" transform="translate(0.5)"/>
    </clipPath>
    </defs>

  `
};
export {
  t as PhoneAndWatch
};
